<template>
  <div>
    <a-modal width="85%" v-model="leafletsible" style="top: 20px" footer="" title="派单">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" :form="form">
          <a-row v-if="reslist.orderId" style="margin-left: 50px">
            <a-col :span="6">
              企业简称:{{ this.reslist.enterpriseSysName }}
              <a-form-item label="企业简称" style="display: none">
                <a-input v-decorator="['enterpriseSysName']" disabled="disabled" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              品牌: {{ this.reslist.brandName }}
              <a-form-item label="品牌" style="display: none">
                <a-input v-decorator="['brandName']" disabled="disabled" />
              </a-form-item>
              <a title="复制" style="margin-left: 5px">
                <a-icon type="copy" class="copy" @click="Copys" />
              </a>
            </a-col>
            <a-col :span="6">
              型号: {{ this.reslist.modelName }}
              <a-form-item label="型号" style="display: none">
                <a-input v-decorator="['modelName']" disabled="disabled" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="reslist.orderId" style="margin-left: 50px">
            <a-col :span="6">
              客户姓名:{{ this.reslist.clientName }}
              <a-form-item label="客户姓名" style="display: none">
                <a-input v-decorator="['clientName']" disabled="disabled" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              联系方式: {{ this.reslist.clientPhone }}
              <a-form-item label="联系方式" style="display: none">
                <a-input v-decorator="['clientPhone']" disabled="disabled" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              客户地址: {{ this.reslist.clientAddress }}
              <a-form-item label="客户地址" style="display: none">
                <a-input v-decorator="['clientAddress']" disabled="disabled" />
              </a-form-item>
            </a-col>
          </a-row>
          <div style="margin: 20px; background-color: #e6f7ff" v-if="reslist.orderId">
            <a-row style="padding: 0px">
              <a-col :span="24" class="orderKeyword">
                <span></span>
              </a-col>
            </a-row>
         
          </div>

          <a-row style="margin-left: 20px; margin-top: 20px">
            <a-col :span="5">
              <a-form-item label="姓名/电话">
                <a-input v-decorator="['nameOrPhone']" />
              </a-form-item>
            </a-col>
            <a-col :span="4">
              <a-form-item label="省" style="margin-left: 10px">
                <a-select @change="getselect" v-decorator="['provinceId']" :allowClear="true">
                  <a-select-option v-for="type in selectAllProvince" :key="type.provinceCode">
                    {{ type.provinceName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="4">
              <a-form-item label="市" style="margin-left: 10px">
                <a-select v-decorator="['cityId']" @change="getprovinceName" :allowClear="true">
                  <a-select-option v-for="type in selectCityName" :key="type.cityCode">
                    {{ type.cityName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="4" style="margin-left: 10px">
              <a-form-item label="区">
                <a-select v-decorator="['countyId']" :allowClear="true">
                  <a-select-option v-for="type in selectAreaName" :key="type.areaCode">
                    {{ type.areaName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="" style="width: 100%">
                <a-button type="primary" style="margin-left: 10px" @click="masterleafletsInquiry"> 查询师傅 </a-button>
                <a-button type="primary" style="margin-left: 10px" @click="masterQuery"> 默认查询 </a-button>

              </a-form-item>
            </a-col>     
          </a-row>

          <a-table
            size="default"
            ref="table"
            rowKey="orderId"
            :columns="distributecolumns"
            :dataSource="this.distributedata"
            bordered
            :pagination="false"
            :scroll="{ x: 180 }"
          >
            <span slot="action" slot-scope="text, record">           
              <a  @click="masterLeafletsDistribute(record)">改派</a>
            </span>
            <span slot="totalScore" slot-scope="text, record">
              <a-popover>
                <template slot="content">
                  <LockanRadar
                    :no="record.no"
                    :data="record.data"
                    :data1="record.data1"
                    :indicator="record.indicator"
                  ></LockanRadar>
                </template>
                <a type="primary">
                  <!--<LockanRadar :no="record.no" :data="record.data" :data1="record.data1" :indicator="record.indicator"></LockanRadar>-->
                  {{ record.totalScore }}
                </a>
              </a-popover>
            </span>
         
          </a-table>
        </a-form>
      </div>
    </a-modal>
    <a-modal :mask="false" style="top: 20px" :width="650" v-model="chartRadarible" footer="">
      <div @click="clickMe" id="myChart" :style="{ width: '500px', height: '500px', marginLeft: '50px' }"></div>
    </a-modal>
    <a-modal
      style="top: 40px"
      title="提示"
      :width="400"
      v-model="auditAmountible"
      footer=""
      @cancel="auditAmountiblecancel"
    >
      <P v-for="item in MasterInforows">{{ item }}</P>
      <!--订单号-->
    </a-modal>
    <edit-order-model
      v-if="$store.state.user_type == 1"
      ref="editordermodel"
      @ok="$refs.table.refresh(true)"
    ></edit-order-model>
    <edit-order-model1 v-else ref="editordermodel" @ok="$refs.table.refresh(true)"></edit-order-model1>
  </div>
</template>
<script>
import { getdemandlist } from '@/api/order/NewlyaddedOrderList'
import { LockanRadar } from '@/components'
import pick from 'lodash.pick'
import G2 from '@antv/g2'
import { getselectAllProvince, getselectCityName, getselectAreaName } from '@/api/order/orderList'
import {
  getselectAreaPrincipalList,
  getselectAreaPrincipalByCityId,
  getselectPriceName,
  getmasterList,
  reDispatch,
  gethistoryMaster,
  receiveOrder
} from '@/api/order/MasterLeafletsDistribute'
export default {
  name: 'masterLeafletsDistribute',
  components: {
    LockanRadar,
    editOrderModel: () => import('@/views/order/modules/editOrderModel'),
    editOrderModel1: () => import('@/views/order/modules/editOrderModel1'),
    // 注册弹框组件
  },
  data() {
    return {
      copyData: '',
      dividerdis: false,
      auditAmountible: false,
      leafletsible: false,
      searchParam: '',
      chartRadarible: false,
      distributedata: [],
      MasterInforows: [],
      orderStatus:'',
      distributecolumns: [
  
        {
          title: '操作栏',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
        {
          title: '团队你名称',
          dataIndex: 'teamName',
          align: 'center',
        },
        {
          title: '团员姓名',
          dataIndex: 'memberName',
          align: 'center',
        },
        {
          title: '联系方式',
          dataIndex: 'memberPhone',
          scopedSlots: { customRender: 'memberPhone' },
          align: 'center',
        }
      ],
 
      selectAllProvince: [],
      selectCityName: [],
      selectAreaName: [],
      reslist: '',
      form: this.$form.createForm(this),
      showchartrecord: '',
      enterpriseamount: false,

    }
  },

  methods: {
    // 复制
    handcopy(data) {
      let url = data
      let oInput = document.createElement('textArea')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      console.log(oInput.value)
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message.success('复制成功')
      oInput.remove()
    },
    Copys() {
      let brandName = this.form.getFieldValue('brandName') ? this.form.getFieldValue('brandName') : ''
      let modelName = this.form.getFieldValue('modelName') ? this.form.getFieldValue('modelName') : ''
      let clientName = this.form.getFieldValue('clientName') ? this.form.getFieldValue('clientName') : ''
      let clientPhone = this.form.getFieldValue('clientPhone') ? this.form.getFieldValue('clientPhone') : ''
      let clientAddress = this.form.getFieldValue('clientAddress') ? this.form.getFieldValue('clientAddress') : ''
      this.copyData =
        `品牌: ` +
        brandName +
        '\n' +
        `型号: ` +
        modelName +
        '\n' +
        `客户姓名: ` +
        clientName +
        '\n' +
        `联系方式: ` +
        clientPhone +
        '\n' +
        `客户地址: ` +
        clientAddress
      this.handcopy(this.copyData)
    },
    masterleafletsInquiry() {
  
      if (this.reslist.orderId) {
        getmasterList({
          installTypeCode: this.reslist.installType,
          provinceId: this.form.getFieldValue('provinceId'),
          cityId: this.form.getFieldValue('cityId'),
          areaCode: this.form.getFieldValue('countyId'),
          nameOrPhone: this.form.getFieldValue('nameOrPhone'),
          orderId: this.reslist.orderId,
        }).then((res) => {
          if (res.code === 0) {
            this.distributedata = []
            res.rows.forEach((item) => {              
              this.distributedata.push(item)
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        getmasterList({
          installTypeCode: this.searchParam.installType,
          provinceId: this.form.getFieldValue('provinceId'),
          cityId: this.form.getFieldValue('cityId'),
          nameOrPhone: this.form.getFieldValue('nameOrPhone'),
          areaCode: this.form.getFieldValue('countyId'),
        }).then((res) => {
          if (res.code === 0) {
            this.distributedata = []
            res.rows.forEach((item) => {
              this.distributedata.push(item)
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    masterQuery() {
      this.showleaflets(this.reslist)
    },

    async showleaflets(reslist) {
      this.reslist = reslist;
      this.orderStatus = reslist.orderStatusName;
      if (this.reslist.orderId) {
        this.dividerdis = true
        this.leafletsible = true
        this.selectAreaName = []
        getselectAreaName({ cityCode: this.reslist.cityId }).then((res) => {
          if (res.code === 0) {
            this.selectAreaName = res.rows
          } else {
            this.$message.error(res.msg)
          }
        })

        this.distributecolumns = [
         
          {
            title: '操作栏',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
            align: 'center',
          },
          {
          title: '团队你名称',
          dataIndex: 'teamName',
          align: 'center',
          },
          {
            title: '团员姓名',
            dataIndex: 'memberName',
            align: 'center',
          },
          {
            title: '联系方式',
            dataIndex: 'memberPhone',
            scopedSlots: { customRender: 'memberPhone' },
            align: 'center',
          }
        ]


        getselectPriceName({ orderIdList: [this.reslist.orderId] }).then((res) => {
          if (res.code === 0) {
          } else {
            //提示
            //this.$message.error(res.msg)
          }
        })
        await getmasterList({
          installTypeCode: this.reslist.installType,
          provinceId: this.reslist.provinceId,
          cityId: this.reslist.cityId,
          areaCode: this.reslist.countyId,
          orderId: this.reslist.orderId,
        }).then((res) => {
          if (res.code === 0) {
            this.distributedata = [];
            res.rows.forEach((item) => {
              this.distributedata.push(item)
            })
          } else {
            this.$message.error(res.msg)
          }
        })
        this.selectCityName = []
        getselectCityName({ provinceCode: this.reslist.provinceId }).then((res) => {
          if (res.code === 0) {
            /* console.log(res)*/
            this.selectCityName = res.rows
          } else {
            this.$message.error(res.msg)
          }
        })
        this.$nextTick(() => {
          this.form.setFieldsValue(
            pick(
              this.reslist,
              'brandName',
              'clientAddress',
              'clientName',
              'clientPhone',
              'enterpriseSysName',
              'modelName',
              'provinceId',
              'cityId',
              'countyId'
            )
          )
        })
      } else {
        this.dividerdis = false
        getselectPriceName({ orderIdList: this.reslist }).then((res) => {
          if (res.code === 0) {
            this.leafletsible = true
            // 批量返回的数据
            this.searchParam = res.data.searchParam
            getmasterList({
              installTypeCode: res.data.searchParam.installType,
              provinceId: res.data.searchParam.provinceId,
              cityId: res.data.searchParam.cityId,
              areaCode: res.data.searchParam.districtId,
            }).then((res) => {
              if (res.code === 0) {
                this.distributedata = []
                res.rows.forEach((item) => {
                  this.distributedata.push(item)
                })
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            //提示
           // this.$message.error(res.msg)
          }
        })
      }
    },

    auditAmountiblecancel() {
      this.leafletsible = false
      this.auditAmountible = false
    },

    masterLeafletsDistribute(record) {
      console.log(record)
      if (this.reslist.orderId) {
        reDispatch({
          orderId: this.reslist.orderId,
          teamId: record.teamId,
          memberPhone: record.memberPhone,
          memberId: record.memberId
        }).then((res) => {
          if (res.code === 0) {
             this.leafletsible = false
            this.$emit('ok')
            this.$emit('leafletsok')
            this.$message.success('操作成功')
          } else {
            this.$message.error(res.msg)
          }
        })
      } 
    },

    clickMe() {
      this.chartRadarible = false
    },

    /* 获取市 省更改*/
    getselect(e) {
      // if(e){
      getselectCityName({ provinceCode: e }).then((res) => {
        if (res.code === 0) {
          /* console.log(res)*/
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
      getselectAreaPrincipalList({ provinceId: e }).then((res) => {
        if (res.code === 0) {
          console.log(res)
          this.form.setFieldsValue({
            areaPrincipal: res.data,
          })
        } else {
          this.$message.error(res.msg)
        }
      })
      // }

      this.form.setFieldsValue({
        cityId: '',
      })
      this.form.setFieldsValue({
        countyId: '',
      })
    },
    /* 获取区 市更改*/
    getprovinceName(e) {
      getselectAreaName({ cityCode: e }).then((res) => {
        if (res.code === 0) {
          /* console.log(res)*/
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
      this.form.setFieldsValue({
        countyId: '',
      })

    },
  },
  async created() {
    this.selectAllProvince = []
    await getselectAllProvince().then((res) => {
      if (res.code === 0) {
        this.selectAllProvince = res.rows
      } else {
        this.$message.error(res.msg)
      }
    })
  },
}
</script>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 6px 16px;
}
</style>